import React, { createContext, useState } from 'react';
import { useEffect } from 'react';
import { httpRequest } from '../api/helper';
import backendInstance from '../api/axiosInstance';
import { useNotification } from './NotificationContext';
import { DEFAULT_ERROR_MESSAGE, AUTH_URLS } from '../common/AppConstants';
import logger from '../logger';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const { addNotification } = useNotification();
  const [authLoading, setAuthLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem('accessToken') || null,
  );
  const [backupToken, setBackupToken] = useState(
    localStorage.getItem('backupToken') || null,
  );

  useEffect(() => {
    // Automatically log in if accessToken is found in localStorage
    if (accessToken !== null && accessToken !== undefined && accessToken !== "undefined") {
      // logger.log(`accessToken found in localStorage - ${accessToken}`);
      // logger.log(`backupToken - ${backupToken}`);
      backendInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      setLoggedIn(true);
    } else {
      delete backendInstance.defaults.headers.common['Authorization'];
      setLoggedIn(false);
    }
    setAuthLoading(false);
  }, [accessToken]);

  const login = (accessToken, backupToken) => {
    localStorage.setItem('accessToken', accessToken);
    setAccessToken(accessToken);
    localStorage.setItem('backupToken', backupToken);
    setBackupToken(backupToken);
  };

  const logout = async () => {
    // Logout from BE - expire tokens
    const data = {
      refresh: backupToken,
    };
    await httpRequest({
      method: 'POST',
      url: AUTH_URLS.EXPIRE_TOKEN,
      data: data,
      addNotification,
    });

    // Logout from FE - remove tokens
    localStorage.removeItem('backupToken');
    setBackupToken(null);
    localStorage.removeItem('accessToken');
    setAccessToken(null);
  };

  const refreshToken = async () => {
    logger.log('refreshToken called');
    try {
      if (backupToken === null || backupToken === undefined || backupToken === "undefined") {
        logger.log('No backupToken found');
        return null;
      }
      const newToken = await generateToken();
      return newToken;
    } catch (error) {
      logger.error('Failed to refresh accessToken', error);
      logout(); // Optional: logout the user if accessToken refresh fails
      return null;
    }
  };

  // Assuming you have a method to request a new accessToken using a backup token
  const generateToken = async () => {
    // const backupToken = localStorage.getItem('backupToken');
    const data = {
      refresh: backupToken,
    };
    let token = null;

    await httpRequest({
      method: 'POST',
      url: AUTH_URLS.REFRESH_TOKEN,
      data: data,
      onSuccess: (data) => {
        login(data.access, backupToken);
        token = data.access;
      },
      onFailure: (data) => {
        logout();
      },
      addNotification,
    });
    
    return token;
  };

  return (
    <AuthContext.Provider
      value={{
        authLoading,
        loggedIn,
        accessToken,
        login,
        logout,
        refreshToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
